import { useMatch } from "react-router";
import { useStaticInfo } from "../../../hooks/useStaticInfo";
import { Routes } from "../../../routing/routes";
import { Offering } from "../../../shared/types";

const useActiveOffering = (): Offering | null => {
  const { basePath } = useStaticInfo();

  const matchesWithCompleteYourLookRoute = useMatch(`/${basePath}/${Routes.COMPLETE_YOUR_LOOK}`);
  const matchesWithCompleteYourLookByAnchorGarmentRoute = useMatch(`/${basePath}/${Routes.LOOKS_BY_ANCHOR_GARMENT}`);

  const matchesWithTrendingForYouRoute = useMatch(`/${basePath}/${Routes.TRENDING_FOR_YOU}`);

  const matchesWithCategoriesRootRoute = useMatch(`/${basePath}/${Routes.CATEGORIES}`);
  const matchesWithSpecificCategoriesRoute = useMatch(`/${basePath}/${Routes.CATEGORY}`);

  const matchesWithSalesRootRoute = useMatch(`/${basePath}/${Routes.SALES}`);
  const matchesWithSpecificSaleCategoriesRoute = useMatch(`/${basePath}/${Routes.SALE}`);

  if (matchesWithCompleteYourLookRoute || matchesWithCompleteYourLookByAnchorGarmentRoute) {
    return Offering.COMPLETE_YOUR_LOOK;
  }

  if (matchesWithTrendingForYouRoute) {
    return Offering.TRENDING_FOR_YOU;
  }

  if (matchesWithCategoriesRootRoute || matchesWithSpecificCategoriesRoute) {
    return Offering.CATEGORIES;
  }

  if (matchesWithSalesRootRoute || matchesWithSpecificSaleCategoriesRoute) {
    return Offering.SALES;
  }

  return null;
};

export { useActiveOffering };
